import React, { useState } from "react"
import PropTypes from 'prop-types'
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

//i18n
import { withTranslation } from "react-i18next"
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter"
import { useTenant } from "../../../hooks/useTenant";

// users
import user1 from "../../../assets/images/users/user-1.jpg"

const ProfileMenu = props => {
  const [menu, setMenu] = useState(false)
  const { user, claims } = useTenant();
  const isSuperAdmin = claims?.role === "super_admin";

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn neo-profile-trigger waves-effect d-flex align-items-center"
          id="page-header-user-dropdown"
          tag="button"
          style={{
            height: '48px',
            padding: '4px 16px 4px 6px',
            borderRadius: '26px',
            border: menu ? '2px solid var(--color-brand-primary)' : '1.5px solid rgba(72, 39, 18, 0.12)',
            backgroundColor: menu ? 'var(--color-bg-surface)' : 'transparent',
            transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
            display: 'inline-flex',
            alignItems: 'center',
            boxShadow: menu ? 'var(--shadow-premium-soft)' : 'none',
            outline: 'none'
          }}
        >
          <img
            className="rounded-circle header-profile-user"
            src={user?.photoURL || user?.picture || user1}
            alt="Header Avatar"
            style={{ 
              width: '36px', 
              height: '36px', 
              border: '2px solid var(--color-brand-primary)',
              objectFit: 'cover'
            }}
          />
          <div className="d-none d-sm-flex flex-column align-items-start ms-2 text-start" style={{ lineHeight: '1.2' }}>
            <span className="profile-user-name" style={{ fontSize: '11.5px', fontWeight: '800', color: 'var(--color-brand-primary)', letterSpacing: '0.3px' }}>
              {user?.displayName || user?.fullName || "Usuário"}
            </span>
            <span style={{ fontSize: '10px', fontWeight: '600', color: 'var(--color-brand-secondary)' }}>
              {user?.email || "Sem e-mail"}
            </span>
          </div>
          <i className="mdi mdi-chevron-down d-none d-sm-block ms-2" style={{ color: "var(--color-brand-secondary)", fontSize: '16px' }}></i>
        </DropdownToggle>

        <DropdownMenu
          className="dropdown-menu-end neo-profile-dropdown"
          style={{
            minWidth: '230px'
          }}
        >
          {/* Menu Header */}
          <div className="px-3 py-2 d-flex flex-column mb-2" style={{ borderBottom: '2px solid #ebdcc5', paddingBottom: '12px' }}>
            <span style={{ fontWeight: '900', color: '#4a2c11', fontSize: '0.85rem', textTransform: 'uppercase', fontFamily: "'Outfit', sans-serif" }}>
                {user?.displayName || user?.fullName || "Usuário"}
            </span>
            <span className="font-size-11 text-truncate" style={{ color: '#784b22', fontWeight: '600' }}>
                {user?.email || "Sem e-mail"}
            </span>
          </div>

          {/* Platform Admin Option for Super Admins */}
          {isSuperAdmin && (
            <DropdownItem tag={Link} to="/platform" className="mt-2 mb-1">
              <div className="avatar-xs">
                <span className="avatar-title" style={{ backgroundColor: 'rgba(59, 93, 231, 0.08)', color: '#3b5de7' }}>
                  <i className="mdi mdi-shield-crown-outline" />
                </span>
              </div>
              {props.t("Painel da Plataforma")}
            </DropdownItem>
          )}

          {/* Profile Item */}
          <DropdownItem tag={Link} to="/profile" className={isSuperAdmin ? "mb-1" : "mt-2 mb-1"}>
            <div className="avatar-xs">
              <span className="avatar-title" style={{ backgroundColor: 'rgba(234, 88, 12, 0.08)', color: '#ea580c' }}>
                <i className="mdi mdi-account-outline" />
              </span>
            </div>
            {props.t("Meu Perfil")}
          </DropdownItem>

          {/* Settings Item */}
          <DropdownItem tag={Link} to="/settings/company" className="mb-1">
            <div className="avatar-xs">
              <span className="avatar-title" style={{ backgroundColor: 'rgba(120, 75, 34, 0.06)', color: '#784b22' }}>
                <i className="mdi mdi-cog-outline" />
              </span>
            </div>
            {props.t("Configurações")}
          </DropdownItem>

          {/* Billing Item */}
          <DropdownItem tag={Link} to="/settings/billing" className="mb-2">
            <div className="avatar-xs">
              <span className="avatar-title" style={{ backgroundColor: 'rgba(217, 119, 6, 0.08)', color: '#d97706' }}>
                <i className="mdi mdi-credit-card-outline" />
              </span>
            </div>
            {props.t("Financeiro")}
          </DropdownItem>

          <div className="dropdown-divider border-0 my-2" style={{ borderTop: '2px solid #ebdcc5' }} />

          {/* Logout Item */}
          <DropdownItem tag={Link} to="/logout" className="text-danger">
            <div className="avatar-xs">
              <span className="avatar-title" style={{ backgroundColor: 'rgba(239, 68, 68, 0.08)', color: '#ef4444' }}>
                <i className="mdi mdi-logout" />
              </span>
            </div>
            <span>{props.t("Sair do Sistema")}</span>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(ProfileMenu));